module.exports = __webpack_public_path__ + "static/media/errorIcon.c3c37263.png";